/**
 * Login page — email + password, posts to /api/auth/login.
 */
import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthAPI, auth, errorMessage } from '../services/api';

export default function Login() {
    const navigate = useNavigate();
    const location = useLocation();
    const redirectTo = location.state?.from?.pathname || '/';

    const [email, setEmail]       = useState('');
    const [password, setPassword] = useState('');
    const [error, setError]       = useState(null);
    const [busy, setBusy]         = useState(false);

    function validate() {
        if (!email.includes('@')) return 'Enter a valid email.';
        if (password.length < 8)  return 'Password must be at least 8 characters.';
        return null;
    }

    async function handleSubmit(e) {
        e.preventDefault();
        const v = validate();
        if (v) { setError(v); return; }

        try {
            setBusy(true);
            setError(null);
            const data = await AuthAPI.login({ email, password });
            auth.set(data);
            navigate(redirectTo, { replace: true });
        } catch (err) {
            setError(errorMessage(err));
        } finally {
            setBusy(false);
        }
    }

    return (
        <div className="max-w-md mx-auto mt-10 bg-white border border-gray-200 rounded-lg p-6">
            <h1 className="text-xl font-semibold text-gray-900">Welcome back</h1>
            <p className="mt-1 text-sm text-gray-500">Log in to your dashboard.</p>

            <form className="mt-6 space-y-4" onSubmit={handleSubmit} noValidate>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Email</label>
                    <input
                        type="email"
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="mt-1 w-full border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Password</label>
                    <input
                        type="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="mt-1 w-full border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
                    />
                </div>

                {error && <div className="text-sm text-red-600">{error}</div>}

                <button
                    type="submit"
                    disabled={busy}
                    className="w-full rounded bg-brand-500 text-white font-medium py-2 hover:bg-brand-600 disabled:opacity-50"
                >
                    {busy ? 'Signing in…' : 'Sign in'}
                </button>
            </form>

            <p className="mt-4 text-sm text-gray-600">
                No account? <Link to="/signup" className="text-brand-600 underline">Create one</Link>
            </p>
        </div>
    );
}
